export class Range {
  static Default = [
    new Range(0, 7),
    new Range(7, 14),
    new Range(14, 21),
    new Range(21, 28),
    new Range(28, 35),
    new Range(35, 42),
    new Range(42, 50, 1),
    new Range(50, 55),
    new Range(55, 60),
    new Range(60, 65, 2),
    new Range(65, 70),
    new Range(70, 75),
    new Range(75, 82, 3),
    new Range(82, 88),
    new Range(88, 94),
    new Range(94, 100, 4)
  ]

  constructor(min = 0, max = 100, gear = 0) {
    this.min = min
    this.max = max
    this.gear = gear
  }
}



// WEBPACK FOOTER //
// ./packages/dof-gear/range.js